export const SUPPORT_SEATS_API_URL = 'ui/partner/support_seats';

export const supportSeatsQueryKeys = {
  base: [SUPPORT_SEATS_API_URL],
};
